import { Typography } from "@mui/material";

import { Box, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import GreetingHeader from "../../components/GreetingHeader";
import CustomButton from "../../components/CustomButton";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";

import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";
import { saveAs } from "file-saver";
import isEmptyArray from "lodash/isEmpty";
import SearchBarFilter from "../../components/SearchBarFilter";

import {
  selectedItems,
  selectedSidebarTab,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  SOME_ERROR_OCCURRED,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import DebugLog, { printLog } from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  downloadCreditDebitAccounttReports,
  getCreditDebitAuditActivityDetails,
  getCreditDebitDetails,
  } from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import {
  debitCreditAccountDetailsColumnHeader,
  } from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import UserActivityInfo from "../../components/UserActivity";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import EarmarkHighlightStats from "../../components/EarmarkHighlightedStats";
import { AuthContext } from "../../context/AuthContext";
import { DownloadFileWithDatePickerSelectionDialog } from "../../components/DownloadFileWithDatePickerSelectionDialog";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
    {
        keyValue: 'Account Name',
        displayName: 'Name',
        paramName: 'NAME',
        isDateFilter: false,
        isSearchBarDropdown: false,
        searchBarDropdownOptions: [],
    },

    {
        keyValue: 'Account Code',
        displayName: 'Code',
        paramName: 'CODE',
        isDateFilter: false,
        isSearchBarDropdown: false,
        searchBarDropdownOptions: [],
    },
    {
        keyValue: 'Type',
        displayName: 'Type',
        paramName: 'TYPE',
        isDateFilter: false,
        isSearchBarDropdown: false,
        searchBarDropdownOptions: [],
    },
    {
        keyValue: 'Details Description',
        displayName: 'Description',
        paramName: 'DETAILS',
        isDateFilter: false,
        isSearchBarDropdown: false,
        searchBarDropdownOptions: [],
    },
    {
        keyValue: 'Status',
        displayName: 'Status',
        paramName: 'STATUS',
        isDateFilter: false,
        isSearchBarDropdown: true,
        searchBarDropdownOptions: [
          'Cancelled', 
          'Posted', 
          'Error', 
          'Scheduled'
        ],
    },
    // {
    //   keyValue: 'Date',
    //   displayName: 'Date',
    //   paramName: 'transactionDate',
    //   isDateFilter: true,
    //   isSearchBarDropdown: false,
    //   searchBarDropdownOptions: [],
    // },
    {
        keyValue: 'Amount',
        displayName: 'Amount',
        paramName: 'AMOUNT',
        isDateFilter: false,
        isSearchBarDropdown: false,
        searchBarDropdownOptions: [],
    },
];

export function CreditDebitScreen() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [totalCreditAccount, setTotalCreditAccount] = useState("");
  const [totalDebitAccount, setTotalDebitAccount] = useState("");

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [earmarkActivityDetails, setearmarkActivityDetails] = useState([]);

  const [creditDebitDetails, setCreditDebitDetails] = useState([]);

  const [gridHeight, setGridHeight] = useState(500); // Default height

  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selected, setSelected] = useAtom(selectedSidebarTab);

  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [creditDebitAccountAuditActivity, setCreditDebitAccountAuditActivity] =
    useState("");
  const [selectedDateRange, setSelectedDateRange] = useState(
    CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS
  );
  const [reset, setReset] = useState(0);
  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(15);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [addAjustmentVisible, setAddAdjustmentButton] = useState(false);
  const [editAllowed, setEditAllowed] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  // pagination

  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // sort model
  const [sortModel, setSortModel] = useState([]);

  // sorting handling 
  useEffect(() => {
    requestCreditDebitDetailsData(paginationModel.page, paginationModel.pageSize, selectedFilter, searchQuery);
  }, [sortModel]);

  // user context
  const { authDetails } = React.useContext(AuthContext);
  useEffect(() => {
    requestCreditDebitDetailsData(
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );

    getCreditDebitActivityAuditDetails(activityCurrentPage, selectedDateRange);

    updateButtonVisibility();
  }, []);

  useEffect(() => {
    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [
    isNetworkConnectionAvailable,
    enqueueSnackbar,
    navigate,
    totalNoOfRows,
    rowsPerPage,
  ]);

  const handleOpen = () => {
    setOpen(true);
  };
  const updateButtonVisibility = () => {
    try {
      if (authDetails.sessionId !== "") {
        const userDetails = authDetails.userAccessDetails.menuList;

        let adjustments = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Adjustment") {
                adjustments = [...item.menuItem];
              }
            });

            adjustments.forEach((itemA, index) => {
              if (itemA.menuName === "Debit/Credit") {
                const actionButtonList = [...itemA.actionButton];

                actionButtonList.forEach((items, index) => {
                  if (items.buttonName === "DOWNLOAD") {
                    setDownlaodButton(true);
                  } else if (items.buttonName === "ADD ADJUSTMENT") {
                    setAddAdjustmentButton(true);
                  } else if (items.buttonName === "EDIT") {
                    setEditAllowed(true);
                  }
                });
              }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    DebugLog("Dialog Closed");
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    DebugLog("Selected Date " + selectedDate);
  };

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 10; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (totalNoOfRows <= pageSize) {
      rowCount = totalNoOfRows; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    requestCreditDebitDetailsData(0, newPageSize, selectedFilter, searchQuery);
  };
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };
  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    requestCreditDebitDetailsData(newPage, paginationModel.pageSize, selectedFilter, searchQuery);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    requestCreditDebitDetailsData(newPage, paginationModel.pageSize, selectedFilter, searchQuery);
  };

  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getCreditDebitActivityAuditDetails(newPage, selectedDateRange);
  };

  function addNewAdjustment() {
    navigate(CONSTANT.ADD_ADJUSTMENTS_ROUTE, { data: null, type: "1" });
    // setOpen(true);
  }

  function downloadAdjustment(fileType, startDate, endDate) {
    try {
      if (isNetworkConnectionAvailable) {
        // const formatStartDate = dayjs(startDate).format('DD/MM/YYYY')
        // const formatEndDate = dayjs(endDate).format('DD/MM/YYYY')

        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          fromDate: startDate,
          toDate: endDate,
          // accountCode: params.code,
          // accountName: params.name,
          // reason: params.reason,

          reportTemplate: "ADJUSTMENT_REPORT",
          reportFormat: fileType,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CREDIT_DEBIT_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadCreditDebitAccounttReports(requestData)
            .then((response) => {
              setLoading(false);

              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                // setJsonData(jsonObject);
                printLog("JSON data:", JSON.stringify(jsonObject));

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    showErrorAlert(ERROR, jsonObject.displayErrorMessage);
                  } else {
                    showErrorAlert(ERROR, jsonObject.errorDescription);
                  }
                }
              } else {
                let blob;
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, "0");
                const month = String(currentDate.getMonth() + 1).padStart(
                  2,
                  "0"
                );
                const year = String(currentDate.getFullYear());

                // let filename be "EarmarkReport_YYYY-MM-DD"
                let filename = `CreditDebitReport_${year}-${month}-${day}`;
                switch (fileType) {
                  case "CSV":
                    blob = new Blob([response.data], { type: "text/csv" });
                    filename = filename + ".csv";
                    break;
                  case "XLS":
                    blob = new Blob([response.data], {
                      type: "application/vnd.ms-excel",
                    });
                    filename = filename + ".xls";
                    break;
                  case "PDF":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = filename + ".pdf";
                    break;

                  default:
                    throw new Error("Invalid file type");
                }

                // Use FileSaver to save the file
                saveAs(blob, filename);
              }
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),

      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });
    requestCreditDebitDetailsData(0, paginationModel.pageSize, filterParam, searchQuery);
  }


  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getCreditDebitActivityAuditDetails(activityCurrentPage, selectedDateRange);
  };
  function getCreditDebitActivityAuditDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        switch (passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_FREEZE_ACCOUNT_ACTIVITY_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getCreditDebitAuditActivityDetails(requestData)
            .then((response) => {
              setCreditDebitAccountAuditActivity(
                response.data.result.adjustmentAuditDetails.content
              );
              setActivityTotalNoOfPages(
                response.data.result.adjustmentAuditDetails.totalPages
              );
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }
  function requestCreditDebitDetailsData(pageNo, pageSize, filterParam, searchQuery) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
          pageNo,
          pageSize,
          filterParam,
          searchQuery
        );

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EXCLUSION_ITEMS_DETAILS
        ).then((encryptedContentData) => {
          const onholdCompanyRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          getCreditDebitDetails(onholdCompanyRequestData)
            .then((response) => {
              setTotalCreditAccount(response.data.result.totalCredit);
              setTotalDebitAccount(response.data.result.totalDebit);

              setCreditDebitDetails(
                response.data.result.debitCreditDetails.content
              );
              setRowsPerPage(
                response.data.result.debitCreditDetails.content.length
              );
              setTotalNoOfRows(
                response.data.result.debitCreditDetails.totalElements
              );
              setTotalNoOfPages(
                response.data.result.debitCreditDetails.totalPages
              );

              setLoading(false);
            })
            .catch((error) => {
              if (
                error.data !== null &&
                error.data.errorCode != null &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data !== null &&
                error.data.errorCode != null &&
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  // Create Request Object for getEarMarkDetails API
  function createRequestObject(pageNumber, pageSize, selectedFilter, filterValue) {
    // Initialize all fields to null
    let requestObject = {
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchType: "NONE",
      searchKeyword: "",
      isDateRangeProvided: false,
    };

    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject.searchType = selectedFilter;
        requestObject.searchKeyword = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "name":
            requestObject.sortProperty = "NAME";
            break;
          case "code":
            requestObject.sortProperty = "CODE";
            break;
          case "type":
            requestObject.sortProperty = "TYPE";
            break;
          case "details":
            requestObject.sortProperty = "DESCRIPTION";
            break;
          case "date":
            requestObject.sortProperty = "DATE";
            break;
          case "status":
            requestObject.sortProperty = "STATUS";
            break;
            case "amount":
              requestObject.sortProperty = "AMOUNT";
              break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  const handleRowClick = (params) => {
    if (editAllowed === true) {
      if (params.row.isEditable !== false) {
        navigate(CONSTANT.ADD_ADJUSTMENTS_ROUTE, {
          state: { data: params.row, type: "0" },
        });
      }
    }
  };
  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  const openDownloadOptionsDialog = (type) => {
    let title = "";
    if (type === "Download") {
      title = "Download";
    }
    setReset(0);
    setClickedButtonType(type);
    setDialogTitle(title);
    setDownloadFileDialogOpen(true);
  };

  const handleFileDownloadDialogClose = () => {
    setDownloadFileDialogOpen(false);
    setReset(1);
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
    setReset(1);
    if (type === "Cancel") {
      startDate = null;
      endDate = null;
    } else {
      downloadAdjustment(fileType, startDate, endDate);
    }

    setReset(0);
  };
  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />

        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container justifyContent="space-between">
            <Grid item>
              <GreetingHeader name={"Debit / Credit"}></GreetingHeader>
            </Grid>

            <Box position="absolute" right={25} top={60}>
              <SearchBarFilter
                filterProps={filterProps}
                onSearch={handleSearch}
              ></SearchBarFilter>
            </Box>
          </Grid>
          {/* Greetings Header */}
          {/* <button onClick={handleOpen}>Open Date Picker</button> */}
          {/* Highlight Stats */}
          <EarmarkHighlightStats
            highlight0={"Total Credit"}
            highlightTotal={"RM " + totalCreditAccount}
            highlight1={"Total Debit"}
            highlight1Stat={"RM " + totalDebitAccount}
            highlight2={""}
            highlight2Stat={""}
            highlight3={""}
            highlight3Stat={""}
          ></EarmarkHighlightStats>
          {/* Highlight Stats */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            {/* <SectionHeader
              sectionIcon={"../../assets/common/onhold.svg"}
              sectionHeading={"On Hold"}
            ></SectionHeader> */}

            {creditDebitDetails.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={creditDebitDetails}
                  columns={debitCreditAccountDetailsColumnHeader}
                  // components={{ Toolbar: GridToolbar }}
                  //  checkboxSelection
                  // selectionModel={selectedRows}
                  // onSelectionModelChange={handleSelectionChange}
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  disableSelectionOnClick // Disable row selection on row click
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  autoHeight
                  onRowClick={handleRowClick}

                  sortModel={sortModel}
                  onSortModelChange={(model) => setSortModel(model)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {creditDebitDetails.length > 0 ? (
            <Box mt={15}>
              <Typography>
                <span>Jump to page: </span>
                <select value={paginationModel.page + 1} onChange={handlePageJump}>
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* On Hold Section */}

          {/* Action Buttons */}

          <Grid item mt={1} justifyContent={"flex-start"} pb={10}>
            <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
              {addAjustmentVisible === true ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnTxt={"ADD ADJUSTMENT"}
                  onClick={addNewAdjustment}
                ></CustomButton>
              ) : (
                ""
              )}
              {/* {downloadButtonVisible === true ? (
                <DownloadDropdownButton
                  onFileTypeSelected={downloadAdjustment}
                />
              ) : (
                ""
              )} */}
              {downloadButtonVisible ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Download.svg" width={22} />
                  }
                  btnTxt={"Download"}
                  onClick={() => openDownloadOptionsDialog("Download")}
                ></CustomButton>
              ) : (
                ""
              )}
            </Stack>
          </Grid>

          {/* Action Buttons */}

          {/* activity list */}
          <Grid container>
            <UserActivityInfo
              type={"CreditDebitModule"}
              data={creditDebitAccountAuditActivity}
              ondateRangeChange={handleDateRangeChange}
              totalNoOfPages={activityTotalNoOfPages}
              onPageChange={handleActivityPageChange}
            />
          </Grid>

          {/* activity list */}

          {/* Confirmation Dialog */}
          <DownloadFileWithDatePickerSelectionDialog
            open={downloadFileDialogOpen}
            handleClose={handleFileDownloadDialogClose}
            handleSubmit={handleFileDownloadSubmit}
            type={clickedButtonType}
            title={dialogTitle}
            resetIndex={reset}
          />
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
